import React, {useState} from "react";
import { ArticleImage } from "./ImagesArticleStyle";
import { s3_cdn } from "../../utils"
import { connect } from 'react-redux'

import { getArticleBySlug, getArticleBySlugReset, getArticleBySlugState } from '../../action/getArticleBySlugAction'
import config from "../../config";

const ImagesArticle = (props) => {
    console.log("Image Article",props)

    const {getArticleBySlug, getArticleBySlugState} = props 

    // const [imgSrc, setImgSrc] = useState(`${s3_cdn()}article/${getArticleBySlugState.data.image_path}`);
    const [imgSrc, setImgSrc] = useState(`${config.api.s3_url}article/`+getArticleBySlugState.data.image_path);
    // const [imgSrc, setImgSrc] = useState("https://picsum.photos/200");
    console.log("images", imgSrc)

    return (
        <ArticleImage 
        mode={props.type} 
        className="audio"
                    src={imgSrc} >
                    {/* // src="https://picsum.photos/200"> */}
        </ArticleImage>
    );
}

const mapStateToProps = (state) => ({
    getArticleBySlugState: state.getArticleBySlug,
});

const mapDispatchToProps = (dispatch) => ({
    getArticleBySlug: (params) => dispatch(getArticleBySlug(params)),
    getArticleBySlugReset: () => dispatch(getArticleBySlugReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImagesArticle)